import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }

import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddRemoveForm',
  props: {
    icon: {},
    title: {},
    description: {},
    greyBg: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionPanel, {
      greyBg: _ctx.greyBg,
      icon: _ctx.icon,
      title: _ctx.title,
      description: _ctx.description
    }, {
      buttonAction: _withCtx(() => [
        (_ctx.$slots.buttonAction)
          ? _renderSlot(_ctx.$slots, "buttonAction", { key: 0 })
          : _createCommentVNode("", true)
      ]),
      sectionPanelContent: _withCtx(() => [
        (_ctx.$slots.sectionPanelContent)
          ? _renderSlot(_ctx.$slots, "sectionPanelContent", { key: 0 })
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["greyBg", "icon", "title", "description"]),
    (_ctx.$slots.addButton)
      ? _renderSlot(_ctx.$slots, "addButton", { key: 0 })
      : _createCommentVNode("", true)
  ]))
}
}

})